<h3>Sources</h3>
<div style="width: 100%;">Enter at least 3 characters in order to filter.</div>
@if (validationMessage) {
  <div class="alert alert-warning" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ validationMessage }}
  </div>
}
@if (error && errorMessage) {
  <div class="alert alert-danger alert-dismissible fade show" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ errorMessage }}
  </div>
}
<div style="width: 100%;">
  <kendo-grid
    [data]="view | async"
    [loading]="sourcesService.loading"
    [scrollable]="'none'"
    [pageable]="pageableSettings"
    [pageSize]="state.take"
    [skip]="state.skip"
    [filterable]="'row'"
    [filter]="filter"
    (pageChange)="pageChange($event)"
    (filterChange)="filterChange($event)">
    <ng-template kendoGridToolbarTemplate>
      <div class="d-flex w-100 justify-content-end">
        <button type="button" class="btn btn-outline-dark btn-sm" (click)="addSource()" title="Add Source">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </ng-template>
    <ng-template kendoGridLoadingTemplate>
      <div class="d-flex justify-content-center align-items-center" style="height: 60px;">
        <div class="spinner-border alfalaval-blue-color" role="status"></div>
      </div>
    </ng-template>
    <kendo-grid-column field="publishingSource" title="Publishing Source">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="description" title="Description">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="isActive" title="Active" [width]="90">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.isActive ? 'YES' : 'NO' }}
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <select class="form-select form-select-sm" (change)="onIsActiveFilterChange($event, filter)">
          <option value="">All</option>
          <option value="true" [selected]="getFilterValue(filter, 'isActive') === 'true'">YES</option>
          <option value="false" [selected]="getFilterValue(filter, 'isActive') === 'false'">NO</option>
        </select>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="businessContactEmail" title="Business Contact">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="technicalContactEmail" title="Technical Contact">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="serviceNowGroup" title="ServiceNow Group">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="" [width]="90">
      <ng-template kendoGridFilterCellTemplate>
        <span></span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <button class="btn btn-outline-secondary btn-sm me-1" (click)="editSource(dataItem)" title="Edit">
          <i class="fa fa-edit" aria-hidden="true"></i>
        </button>
        <button class="btn btn-outline-secondary btn-sm" (click)="deleteSource(dataItem)" title="Delete">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
